import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Paper,
  Card,
  CardContent,
} from '@mui/material';


import VisibilityIcon from '@mui/icons-material/Visibility';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';

const MissionVision = () => {
  const sidebarSections = [
    {
      id: 'who-we-are',
      label: 'Quiénes Somos',
      path: '/about-us',
      children: [
        { id: 'history', label: 'Nuestra Historia', path: '/about-us/history' },
        { id: 'mission', label: 'Misión y Visión', path: '/about-us/mission-vision' },
        { id: 'values', label: 'Valores Institucionales', path: '/about-us/values' },
        { id: 'calendar', label: 'Calendario Académico', path: '/about-us/calendar' },
      ],
    },
    {
      id: 'services',
      label: 'Servicios',
      path: '/about-us/services',
    },
    {
      id: 'courses',
      label: 'Cursos',
      path: '/about-us/courses',
    },
    {
      id: 'library',
      label: 'Biblioteca',
      path: '/about-us/library',
    },
    {
      id: 'testimonials',
      label: 'Testimoniales',
      path: '/about-us/testimonials',
    },
    {
      id: 'regulations',
      label: 'Reglamentos',
      path: '/about-us/regulations',
    },
  ];

  return (
    <>
     

      <Container maxWidth="xl" sx={{ mb: 8 }}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={3}>
          </Grid>

          <Grid item xs={12} md={9}>
            {/* Vision Card */}
            <Card
              elevation={0}
              sx={{
                mb: 4,
                border: '1px solid #E0E0E0',
                borderRadius: 2,
                overflow: 'hidden',
              }}
            >
              <Box
                sx={{
                  background: 'linear-gradient(135deg, #2B2B6B 0%, #1a1a4a 100%)',
                  p: 3,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                }}
              >
                <VisibilityIcon sx={{ fontSize: 50, color: '#00CED1' }} />
                <Typography
                  variant="h4"
                  sx={{
                    color: 'white',
                    fontWeight: 700,
                    fontSize: { xs: '1.5rem', md: '2rem' },
                  }}
                >
                  Nuestra Visión
                </Typography>
              </Box>
              <CardContent sx={{ p: 4 }}>
                <Typography
                  variant="body1"
                  sx={{
                    color: '#333',
                    fontSize: '1.1rem',
                    lineHeight: 1.8,
                    fontStyle: 'italic',
                    borderLeft: '4px solid #00CED1',
                    pl: 3,
                  }}
                >
                  Ser la institución de educación superior líder en El Salvador, reconocida 
                  internacionalmente por la excelencia académica, la innovación educativa y el 
                  compromiso con el desarrollo integral de nuestros estudiantes, preparándolos 
                  para ser profesionales competitivos en un mundo globalizado.
                </Typography>
              </CardContent>
            </Card>

            {/* Mission Card */}
            <Card
              elevation={0}
              sx={{
                mb: 4,
                border: '1px solid #E0E0E0',
                borderRadius: 2,
                overflow: 'hidden',
              }}
            >
              <Box
                sx={{
                  background: 'linear-gradient(135deg, #E31E24 0%, #C41A1F 100%)',
                  p: 3,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                }}
              >
                <TrackChangesIcon sx={{ fontSize: 50, color: 'white' }} />
                <Typography
                  variant="h4"
                  sx={{
                    color: 'white',
                    fontWeight: 700,
                    fontSize: { xs: '1.5rem', md: '2rem' },
                  }}
                >
                  Nuestra Misión
                </Typography>
              </Box>
              <CardContent sx={{ p: 4 }}>
                <Typography
                  variant="body1"
                  sx={{
                    color: '#333',
                    fontSize: '1.1rem',
                    lineHeight: 1.8,
                    fontStyle: 'italic',
                    borderLeft: '4px solid #E31E24',
                    pl: 3,
                  }}
                >
                  Formar profesionales íntegros y competentes a través de programas académicos 
                  de alta calidad, que combinen la excelencia académica con valores éticos y 
                  responsabilidad social. Facilitamos la proyección internacional de nuestros 
                  estudiantes mediante convenios estratégicos con universidades de prestigio, 
                  y promovemos el desarrollo de competencias lingüísticas, tecnológicas y 
                  emprendedoras que les permitan destacar en sus campos profesionales.
                </Typography>
              </CardContent>
            </Card>

            {/* Strategic Objectives */}
            <Paper
              elevation={0}
              sx={{
                p: 4,
                border: '1px solid #E0E0E0',
                borderRadius: 2,
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                <EmojiObjectsIcon sx={{ fontSize: 40, color: '#2B2B6B' }} />
                <Typography
                  variant="h5"
                  sx={{
                    color: '#2B2B6B',
                    fontWeight: 700,
                    fontSize: { xs: '1.3rem', md: '1.5rem' },
                  }}
                >
                  Objetivos Estratégicos
                </Typography>
              </Box>

              <Grid container spacing={3}>
                {[
                  {
                    title: 'Excelencia Académica',
                    description: 'Mantener y mejorar continuamente la calidad de nuestros programas educativos, asegurando que cumplan con estándares internacionales.',
                  },
                  {
                    title: 'Internacionalización',
                    description: 'Fortalecer alianzas con universidades extranjeras para facilitar la movilidad estudiantil y el reconocimiento de créditos académicos.',
                  },
                  {
                    title: 'Innovación Educativa',
                    description: 'Implementar metodologías pedagógicas modernas y tecnologías educativas que potencien el aprendizaje significativo.',
                  },
                  {
                    title: 'Desarrollo Integral',
                    description: 'Promover el crecimiento personal, profesional y social de nuestros estudiantes a través de programas complementarios.',
                  },
                  {
                    title: 'Responsabilidad Social',
                    description: 'Fomentar el compromiso de nuestra comunidad educativa con el desarrollo sostenible y el bienestar de la sociedad.',
                  },
                  {
                    title: 'Empleabilidad',
                    description: 'Preparar profesionales competitivos con las habilidades y conocimientos demandados por el mercado laboral global.',
                  },
                ].map((objective, index) => (
                  <Grid item xs={12} md={6} key={index}>
                    <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        height: '100%',
                        background: 'linear-gradient(135deg, rgba(43,43,107,0.03) 0%, rgba(0,206,209,0.03) 100%)',
                        border: '1px solid #E0E0E0',
                        borderRadius: 2,
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          transform: 'translateY(-4px)',
                          boxShadow: '0 8px 24px rgba(43,43,107,0.1)',
                          borderColor: '#00CED1',
                        },
                      }}
                    >
                      <Typography
                        variant="h6"
                        sx={{
                          color: '#2B2B6B',
                          fontWeight: 600,
                          mb: 1.5,
                          fontSize: '1.1rem',
                        }}
                      >
                        {objective.title}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#666',
                          lineHeight: 1.6,
                        }}
                      >
                        {objective.description}
                      </Typography>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default MissionVision;